import { render, staticRenderFns } from "./SitePageArticle.vue?vue&type=template&id=be839650&"
import script from "./SitePageArticle.vue?vue&type=script&lang=js&"
export * from "./SitePageArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports